import script from "./SubmissionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionDetailsPage.vue?vue&type=style&index=0&id=9d26e800&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d26e800"]])

export default __exports__